import { ThgCreateMeterReadingDtoGen, ThgCreateThgMeterReadingDtoGen } from "@/services/thg/v1/data-contracts";
import { ImpactTypeEnum } from "@/views/thg/enum/impact-type.enum";

/**
 * @inheritdoc
 */
export class CreateMeterReading implements ThgCreateThgMeterReadingDtoGen {
  /**
   * @inheritdoc
   */
  impactType: ImpactTypeEnum;

  /**
   * @inheritdoc
   */
  impactFactor: number;

  /**
   * @inheritdoc
   */
  isConfirmed?: boolean;

  /**
   * @inheritdoc
   */
  code?: string;

  /**
   * @inheritdoc
   */
  campaign?: string;

  /**
   * @inheritdoc
   */
  meterReading: ThgCreateMeterReadingDtoGen;

  /**
   * Creates an instance
   */
  constructor() {
    this.impactType = ImpactTypeEnum.payout;
    this.impactFactor = 100;
    this.isConfirmed = false;
    this.meterReading = {
      amountInKwh: 0,
      chargingStationId: "",
      endDate: "",
      startDate: "",
      proof: [""]
    };
  }
}
